import {Injectable} from '@angular/core';
import {HttpService} from '@services/http-service';
import {Observable} from 'rxjs';
import {ConfigService} from '@services/webFeeder/config.service';

@Injectable({
  providedIn: 'root'
})
export class DepositService {

  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
  ) {
  }

  getBankAccounts(financialAccount: string, username: string): Observable<any> {
    return this._httpService.doGet(this._configService.getApiWebFeederRest(), `services/negotiation/bankAccountInformation/${financialAccount}/${username}`);
  }
}
